import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ClockStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.937 17.937 22.75 12 22.75C6.06293 22.75 1.25 17.937 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.937 1.25 22.75 6.06293 22.75 12Z"
				fill="currentColor"
			/>
			<path
				d="M11.25 7C11.25 6.58579 11.5858 6.25 12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V11.6895L15.5303 14.4697L15.582 14.5264C15.8223 14.8209 15.8049 15.2557 15.5303 15.5303C15.2557 15.8049 14.8209 15.8223 14.5264 15.582L14.4697 15.5303L11.4697 12.5303C11.3291 12.3896 11.25 12.1989 11.25 12V7Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ClockStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ClockStrokeIcon;
